import Cookies from 'js-cookie';
import axios from 'axios';

export default {
    UPDATE_SESSION (context, value) {
        context.commit('UPDATE_SESSION', value)
    },
    AUTH_REQUEST ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);

            /*setTimeout(() => {
                let temp = {
                    isLogin: true,
                    token: Math.random().toString(36).substring(2, 25)
                }
                commit('AUTH_SUCCESS', temp);
                Cookies.set('isLogin', temp.isLogin);
                Cookies.set('token', temp.token);
                commit('TOGGLE_LOADING', false);
                resolve('all login');
                //reject('reject');
            }, 5000);*/

            axios.post('login/authenticate', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    const temp = {
                        isLogin: true,
                        token: dummyToken(),
                        userInfo: data.payload
                    };
                    Cookies.set('isLogin', temp.isLogin);
                    Cookies.set('token', temp.token);
                    localStorage.setItem('userInfo', JSON.stringify(data.payload));
                    commit('AUTH_SUCCESS', temp);
                    commit('TOGGLE_LOADING', false);
                    resolve(data);

                })
                .catch((error) => {
                    console.log('action login error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });

            /*apiCall({url: 'auth', data: user, method: 'POST'})
                .then(resp => {
                    localStorage.setItem('user-token', resp.token);
                    // Here set the header of your ajax library to the token value.
                    // example with axios
                    // axios.defaults.headers.common['Authorization'] = resp.token
                    commit('AUTH_SUCCESS', resp);
                    dispatch('USER_REQUEST');
                    resolve(resp);
                })
                .catch(err => {
                    commit('AUTH_ERROR', err);
                    localStorage.removeItem('user-token');
                    reject(err);
                })*/
        })
    },
    AUTH_LOGOUT ({commit, dispatch}){
        return new Promise((resolve) => {
            commit('AUTH_LOGOUT', {
                isLogin: false,
                token: '',
                userInfo: {}
            });
            Cookies.remove('isLogin');
            Cookies.remove('token');
            localStorage.removeItem('userInfo');
            resolve();
        })
    }
}

const dummyToken = () => {
    var result = "";
    var generate64baseToken = function(number) {
        if (number <= 0) return 1;
        else {
            result += Math.random().toString(36).substring(2, 25);
            return (number * generate64baseToken(number - 1));
        }
    };
    generate64baseToken(6);
    return result;
};


// WEBPACK FOOTER //
// ./src/store/modules/session/actions.js